export default function admin({ next, router }) {
  const middlewareRole = localStorage.getItem('userRole');
  if (middlewareRole && (Number(middlewareRole) === 1 || Number(middlewareRole) === 2)) {
    return next();
  }
  return router.push('/');
}



// WEBPACK FOOTER //
// ./src/middleware/admin.js